import { client } from "./client";
import type {
  HotToken,
  HotTokenCreateRequest,
  HotTokenUpdateRequest,
} from "../types/HotToken";

export type { HotToken } from "../types/HotToken";

export function apiGetHotTokens(workspaceId: number) {
  return client.get(`/workspaces/${workspaceId}/hot_tokens`);
}

export function apiCreateHotToken(
  workspaceId: number,
  body: HotTokenCreateRequest
) {
  return client.post(`/workspaces/${workspaceId}/hot_tokens`, body);
}

export function apiUpdateHotToken(
  workspaceId: number,
  hotTokenId: number,
  body: HotTokenUpdateRequest
) {
  return client.put(
    `/workspaces/${workspaceId}/hot_tokens/${hotTokenId}`,
    body
  );
}

export function apiDeleteHotToken(workspaceId: number, hotTokenId: number) {
  return client.delete(
    `/workspaces/${workspaceId}/hot_tokens/${hotTokenId}`
  );
}
